import { Link } from "react-router-dom";

export const COLUMN = [
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        sticky: "left",
       
    },
    {
        Header: "Price",
        Footer: "Price",
        accessor: "price",
     
     
    },
    {
        Header: "Quantity",
        Footer: "Quantity",
        accessor: "quantity",
     
     
    }, {
        Header: "Discount",
        Footer: "Discount",
        accessor: "discount",
     
     
    }, {
        Header: "Saving",
        Footer: "Saving",
        accessor: "saving",
     
     
    }, {
        Header: "Total",
        Footer: "Total",
        accessor: "total",
     
     
    }, {
        Header: "Order Date",
        Footer: "Order Date",
        accessor: "OrderDate",
     
     
    },
   
   
];
